import shieldWebMessageWarning from '@assets/images/icons/icon-shield-warning.svg';

import type { TWarningMessageConfig } from './warning.types';
import { useWarningLogic } from './warning.hook';
import { WARNING_STRINGS } from './utils/warning.constants';
import { WebSection, WebImageWrap } from './warning.styles';

export function WarningMessage({ index, newChat = false }: TWarningMessageConfig) {
	const { marginTop } = useWarningLogic();

	return (
		<WebSection index={index ?? 0} marginTop={marginTop} newChat={newChat}>
			<WebImageWrap>
				<img src={shieldWebMessageWarning} alt={WARNING_STRINGS.SHIELD_ALT} />
			</WebImageWrap>

			<div className="content">
				<h4>{WARNING_STRINGS.HEADING}</h4>
				<p>
					{WARNING_STRINGS.TEXT}
				</p>
			</div>
		</WebSection>
	);
}

WarningMessage.displayName = 'WarningMessage';
